import { render, staticRenderFns } from "./OverzichtTokens.vue?vue&type=template&id=69d7dced&scoped=true&"
import script from "./OverzichtTokens.vue?vue&type=script&lang=js&"
export * from "./OverzichtTokens.vue?vue&type=script&lang=js&"
import style0 from "./OverzichtTokens.vue?vue&type=style&index=0&id=69d7dced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d7dced",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
